import Vue from "vue";
Vue.mixin({
    methods: {
        // Concat 2 strings by separator
        concatStrings(str1, str2, separator) {
            let result = '';
            if (str1) {
                result = str1;
            }
            if (str2) {
                if (result) {
                    result = result + separator + str2;
                } else {
                    result = str2;
                }
            }
            return result;
        },
        splitFirstOccurrence(str, separator) {
            if (!str) {
                return [];
            }
            const index = str.indexOf(separator);
            if (index === -1) {
                // Not found
                return [str];
            }
            return [str.substring(0, index), str.substring(index + 1)];
        },
        limitStringLength(str, maxLength) {
            if (!str) {
                return '';
            }
            return str.substring(0, maxLength);
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/string-handling.js